import config from "../../../../config/environment";

/**
 * Resolves API-relative media paths (character Lottie, audio, etc.) to full URLs.
 */
export function resolveContentUrl(
  path?: string | null,
  contentBaseUrl?: string,
): string {
  if (!path?.trim()) {
    return "";
  }

  const trimmed = path.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const base = (contentBaseUrl || config.contentApiUrl || "").replace(/\/$/, "");
  if (!base) {
    return trimmed;
  }

  return trimmed.startsWith("/") ? `${base}${trimmed}` : `${base}/${trimmed}`;
}
